import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Message } from "semantic-ui-react";
import { RemoteFieldState } from "./sequence/ServiceCatalog";

export type ServiceRemoteSelectProps = {
  label: string;
  value: any;
  multiple?: boolean;
  disabled?: boolean;
  required?: boolean;
  state?: RemoteFieldState;
  onSearch: (query: string) => void;
  onChange: (value: any) => void;
};
const ServiceRemoteSelect = (props: ServiceRemoteSelectProps) => {
  const [query, setQuery] = useState<string | null>(null);
  const search = useRef(props.onSearch);
  search.current = props.onSearch;
  useEffect(() => {
    if (query === null || props.disabled) return;
    const timer = setTimeout(() => search.current(query), 300);
    return () => clearTimeout(timer);
  }, [query, props.disabled]);
  const selected = Array.isArray(props.value) ? props.value : [props.value];
  useEffect(() => setQuery(null), [props.value]);
  const options = Array.from(
    new Map(
      [
        ...(props.state?.options || []),
        ...(props.state?.knownOptions || []).filter((option) => selected.includes(option.value)),
      ].map((option) => [option.value, option])
    ).values()
  );
  selected
    .filter(
      (value) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !options.some((option) => option.value === value)
    )
    .forEach((value) => {
      options.push({ key: value, value, text: "ไม่สามารถโหลดชื่อรายการที่เลือก" });
    });
  return (
    <>
      <Dropdown
        fluid
        search={(options) => options}
        selection
        aria-label={props.label}
        searchInput={{ "aria-label": `ค้นหา${props.label}` }}
        placeholder="พิมพ์เพื่อค้นหา..."
        searchQuery={query || ""}
        value={props.value ?? (props.multiple ? [] : "")}
        multiple={props.multiple}
        disabled={props.disabled}
        loading={props.state?.loading}
        clearable={!props.disabled && !props.required}
        renderLabel={
          props.disabled ? (item) => ({ content: item.text, removeIcon: null }) : undefined
        }
        options={options}
        noResultsMessage={props.state?.hint || "ไม่พบรายการ กรุณาพิมพ์คำค้น"}
        onSearchChange={(_, data) => setQuery(data.searchQuery || "")}
        onChange={(_, data) => {
          setQuery(null);
          props.onChange(data.value);
        }}
      />
      {props.state?.hint && (
        <Message info role="status">
          {props.state.hint}
        </Message>
      )}
      {props.state?.error && (
        <Message warning role="status">
          {props.state.error}
        </Message>
      )}
    </>
  );
};
export default ServiceRemoteSelect;
